export enum EnvConfig {
  DEV = 'dev',
  STG = 'stg',
  PROD = 'production',
}
